import { type OrderDetails } from "@koala/sdk";
import { Component } from "react";
import { type ConnectedProps, connect } from "react-redux";
import { StyledLoyaltyContainer } from "../../styles";
import { ConnectedStaticHeartIcon } from "../../uielements";
import { FavoriteOrderCard } from "@/components/account/favorites/favoriteOrder";
import StringAccessor from "@/components/cmsConfig/stringAccessor";
import GenericErrorBoundary from "@/components/genericErrorBoundary";
import {
  StyledFavoritesFlexContainer,
  StyledNoDataContainer,
  StyledNoDataContent,
} from "@/components/uielements/favoriteCard/styles";
import { CSS_CLASSES } from "@/constants/cssClassNames";
import basketActions from "@/redux/basket/actions";
import meActions from "@/redux/me/actions";
import { type RootState } from "@/types/app";

class FavoriteOrders extends Component<ReduxProps> {
  componentDidMount() {
    this.props.fetchMeFavoriteOrders();
  }

  render() {
    const {
      meFavoriteOrders,
      reorderBasket,
      fetchMeOrderDetailsSuccess,
      reorderBasketId,
    } = this.props;

    function handleReorder(orderDetails: OrderDetails) {
      fetchMeOrderDetailsSuccess(orderDetails);
      reorderBasket(orderDetails, "Favorites", true);
    }

    if (!meFavoriteOrders.length) {
      return (
        <StyledLoyaltyContainer>
          <StyledFavoritesFlexContainer
            className={CSS_CLASSES.LOYALTY.PAGE_HEADER}
          >
            <StringAccessor
              tag="h2"
              accessor="favorites.orders_header"
              html={true}
            />
            <StyledNoDataContainer>
              <StyledNoDataContent>
                <ConnectedStaticHeartIcon />
                <StringAccessor
                  tag="h3"
                  accessor="favorites.orders_empty_state_header"
                  html={true}
                />
                <StringAccessor
                  tag="p"
                  accessor="favorites.orders_empty_state_subheader"
                  html={true}
                />
              </StyledNoDataContent>
            </StyledNoDataContainer>
          </StyledFavoritesFlexContainer>
        </StyledLoyaltyContainer>
      );
    }

    return (
      <StyledLoyaltyContainer className={CSS_CLASSES.LOYALTY.PAGE_HEADER}>
        <StyledFavoritesFlexContainer>
          <StringAccessor
            tag="h2"
            accessor="favorites.orders_header"
            html={true}
          />
          {meFavoriteOrders.map((order: OrderDetails, index: number) => (
            <GenericErrorBoundary key={index}>
              <FavoriteOrderCard
                showSubtotal
                order={order}
                index={index}
                reorderBasketId={reorderBasketId}
                reorderBasket={handleReorder}
                eventDetail="Favorites"
              />
            </GenericErrorBoundary>
          ))}
        </StyledFavoritesFlexContainer>
      </StyledLoyaltyContainer>
    );
  }
}

const mapStateToProps = (state: RootState) => ({
  meFavoriteOrders: state.app.me.favoriteOrders,
  reorderBasketId: state.app.basket.reorderBasketId,
});

const mapDispatchToProps = {
  fetchMeFavoriteOrders: meActions.fetchMeFavoriteOrders,
  fetchMeOrderDetailsSuccess: meActions.fetchMeOrderDetailsSuccess,
  reorderBasket: basketActions.reorderBasket,
};

const connector = connect(mapStateToProps, mapDispatchToProps);
type ReduxProps = ConnectedProps<typeof connector>;
export default connector(FavoriteOrders);
